import { z } from 'zod';

export const TenantId = z.string().regex(/^tenant_[a-zA-Z0-9_-]{1,57}$/);
export const SiteId = z.string().regex(/^site_[a-zA-Z0-9_-]{1,59}$/);
export const VisitorKey = z.string().regex(/^vltv_[a-zA-Z0-9-]{1,59}$/);
export const SessionKey = z.string().regex(/^vlts_[a-zA-Z0-9-]{1,59}$/);
export const Cid = z
  .string()
  .trim()
  .min(1)
  .max(128)
  .regex(/^[A-Za-z0-9_.:-]+$/);

export const Attribution = z.object({
  utm_source: z.string().max(255).nullable().optional(),
  utm_medium: z.string().max(255).nullable().optional(),
  utm_campaign: z.string().max(255).nullable().optional(),
  utm_content: z.string().max(255).nullable().optional(),
  utm_term: z.string().max(255).nullable().optional(),
  gclid: z.string().max(255).nullable().optional(),
  fbclid: z.string().max(255).nullable().optional(),
  yclid: z.string().max(255).nullable().optional(),
});

export const EventName = z.enum([
  'video_start',
  'video_progress_25',
  'video_progress_50',
  'video_progress_75',
  'video_complete',
  'video_cta_click',
]);

export const VideoCtaAttribution = z.enum(['explicit', 'same_section', 'inferred', 'unknown']);
